import { Column } from 'src/app/model/common/column';

export const controllerNoteTurnoverColumns: Column[] = [
  {
    field: 'createdAt',
    header: 'Created At',
    formatPattern: 'calendar',
    type: 'calendar',
    sortable: false,
    filterable: false,
  },
  {
    field: 'category',
    header: 'Category',
    formatPattern: 'text',
    sortable: false,
    filterable: false,
  },
  {
    field: 'noteType',
    header: 'Note Type',
    formatPattern: 'text',
    sortable: false,
    filterable: false,
  },
  {
    field: 'facilityName',
    header: 'Facility Name',
    formatPattern: 'text',
    sortable: false,
    filterable: false,
  },
  {
    field: 'entries',
    header: 'Note',
    formatPattern: 'text',
    sortable: false,
    filterable: false,
  },
];
